class UnavailableService {
  isAvailable() {
    return false;
  }
}

export default UnavailableService;
